import type {
  CreateRoasterRequest,
  Roaster,
  RoasterEmployee,
  RoasterMonth,
  StaffRoaster,
} from '@/types';
import api from './api';

export const roasterService = {
  async getEnabledUsers(): Promise<RoasterEmployee[]> {
    const response = await api.get<RoasterEmployee[]>('/roaster/enabled-users');
    return response.data;
  },

  async getAvailableMonths(): Promise<RoasterMonth[]> {
    const response = await api.get<RoasterMonth[]>('/roaster/available-months');
    return response.data;
  },

  async getLast12Months(): Promise<Roaster[]> {
    const response = await api.get<Roaster[]>('/roaster/last-12-months');
    return response.data;
  },

  async getMyAvailableMonths(): Promise<RoasterMonth[]> {
    const response = await api.get<RoasterMonth[]>('/roaster/my-available-months');
    return response.data;
  },

  async getRoasterForMonth(year: number, month: number): Promise<Roaster | null> {
    const response = await api.get<Roaster>(`/roaster/${year}/${month}`);
    return response.data;
  },

  async getMyRoaster(year: number, month: number): Promise<StaffRoaster | null> {
    const response = await api.get<StaffRoaster>(`/roaster/my/${year}/${month}`);
    return response.data;
  },

  async createRoaster(data: CreateRoasterRequest): Promise<Roaster> {
    const response = await api.post<Roaster>('/roaster', data);
    return response.data;
  },

  async updateRoaster(year: number, month: number, data: CreateRoasterRequest): Promise<Roaster> {
    const response = await api.put<Roaster>(`/roaster/${year}/${month}`, data);
    return response.data;
  },

  async deleteRoaster(year: number, month: number): Promise<void> {
    await api.delete(`/roaster/${year}/${month}`);
  },
};

export default roasterService;
